import { render, staticRenderFns } from "./Qa.html?vue&type=template&id=185659cd&scoped=true&"
import script from "./Qa.ts?vue&type=script&lang=ts&"
export * from "./Qa.ts?vue&type=script&lang=ts&"
import style0 from "./Other.css?vue&type=style&index=0&id=185659cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185659cd",
  null
  
)

export default component.exports